module.exports = "<div> <div ui-view></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/billManage/openedInvoice/view/openedInvoice.html
// module id = nwLh
// module chunks = 0